interface StatsCardsProps {
  totalTasks: number;
  completedTasks: number;
  pendingTasks: number;
}

const StatsCards = ({
  totalTasks,
  completedTasks,
  pendingTasks,
}: StatsCardsProps) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
      <div className="bg-white/70 backdrop-blur-sm rounded-[16px] p-6 border border-white/20 shadow-sm">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm font-medium text-gray-600">Total</p>
            <p className="text-3xl font-bold text-gray-900">{totalTasks}</p>
          </div>
          <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center">
            <span className="text-2xl">📋</span>
          </div>
        </div>
      </div>

      <div className="bg-white/70 backdrop-blur-sm rounded-[16px] p-6 border border-white/20 shadow-sm">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm font-medium text-gray-600">Concluídas</p>
            <p className="text-3xl font-bold text-emerald-600">
              {completedTasks}
            </p>
          </div>
          <div className="w-12 h-12 bg-emerald-100 rounded-xl flex items-center justify-center">
            <span className="text-2xl">✅</span>
          </div>
        </div>
      </div>

      <div className="bg-white/70 backdrop-blur-sm rounded-[16px] p-6 border border-white/20 shadow-sm">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm font-medium text-gray-600">Pendentes</p>
            <p className="text-3xl font-bold text-amber-600">{pendingTasks}</p>
          </div>
          <div className="w-12 h-12 bg-amber-100 rounded-xl flex items-center justify-center">
            <span className="text-2xl">⏳</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export { StatsCards };
